// Sol menyu: hansı bölmə kimə və hansı modula görə görünür. Gizlətmə yalnız rahatlıqdır — əsl yoxlama API-dədir.
// KT-99: bölmələr qruplara bölünür (tünd menyu, açılan alt menyu, bölmə rəngi). Paketdə olmayan modul göstərilmir
// (Rüstəm, 01.11 22:16 — kilidli bölmə yoxdur).
import type { ModuleItem } from '@kassa/shared';

export type NavKey =
  | 'products'
  | 'import'
  | 'sales'
  | 'receipts'
  | 'company'
  | 'stock'
  | 'purchase'
  | 'shift'
  | 'returns'
  | 'transfers'
  | 'shipments'
  | 'approvals'
  | 'intake'
  | 'scanner'
  | 'intakeApprovals'
  | 'stockTransfers'
  | 'warehouses'
  | 'financePayment'
  | 'financeAccounts'
  | 'customers'
  | 'contracts'
  | 'suppliers'
  | 'vatCheck'
  | 'reports'
  | 'ai'
  | 'settings';

/** Menyu qrupu; rəngi styles.css-də `--sec-<key>` tokenidir. */
export type NavGroupKey = 'satis' | 'anbar' | 'musteri' | 'maliyye' | 'hesabat' | 'ayar';

export interface NavGroup {
  key: NavGroupKey;
  label: string;
  /** 24×24 SVG yolu (stroke). */
  icon: string;
}

export const GROUPS: NavGroup[] = [
  { key: 'satis', label: 'Satış', icon: 'M6 3h12v18l-3-2-3 2-3-2-3 2z M9 8h6 M9 12h6 M9 16h3' },
  { key: 'anbar', label: 'Mal və anbar', icon: 'M3 7.5 12 3l9 4.5v9L12 21l-9-4.5z M3 7.5l9 4.5 9-4.5 M12 12v9' },
  {
    key: 'musteri',
    label: 'Müştəri və təchizatçı',
    icon: 'M16 20v-1.5a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4V20 M9.5 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z M21 20v-1.5a4 4 0 0 0-3-3.9 M15.5 4.1a3.5 3.5 0 0 1 0 6.8',
  },
  { key: 'maliyye', label: 'Maliyyə', icon: 'M3 6h18v13H3z M3 10h18 M16 15h2' },
  { key: 'hesabat', label: 'Hesabat', icon: 'M4 20V11 M10 20V5 M16 20v-6 M21 20H3' },
  { key: 'ayar', label: 'Sistem', icon: 'M4 6h9 M17 6h3 M15 4v4 M4 12h3 M11 12h9 M9 10v4 M4 18h11 M19 18h1 M17 16v4' },
];

export interface NavSection {
  key: NavKey;
  label: string;
  group: NavGroupKey;
  /** Bu icazə olmadan bölmə gizlənir (null — hamıya). */
  permission: string | null;
  /** Bu modul bağlıdırsa bölmə göstərilmir (null — modula bağlı deyil). */
  module: string | null;
}

// Bənd ikonları (KT-108, maket 25 «Qabiq»): 24×24 stroke yolları
const IC = {
  sale: 'M6 3h12v18l-3-2-3 2-3-2-3 2z M9 8h6 M9 12h6 M9 16h3',
  receipt: 'M5 3h14v18H5z M9 8h6 M9 12h6 M9 16h4',
  doc: 'M6 3h9l4 4v14H6z M14 3v5h5 M9 13h7 M9 17h5',
  ret: 'M9 14l-5-5 5-5 M4 9h10a6 6 0 0 1 0 12h-3',
  shift: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M12 7v5l3 2',
  box: 'M3 7.5 12 3l9 4.5v9L12 21l-9-4.5z M3 7.5l9 4.5 9-4.5 M12 12v9',
  store: 'M4 21V9l8-5 8 5v12 M9 21v-6h6v6',
  truck: 'M3 6h11v10H3z M14 10h4l3 3v3h-7 M7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M17 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
  upload: 'M12 15V4 M7 9l5-5 5 5 M4 15v5h16v-5',
  users: 'M16 20v-1.5a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4V20 M9.5 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z M21 20v-1.5a4 4 0 0 0-3-3.9 M15.5 4.1a3.5 3.5 0 0 1 0 6.8',
  pen: 'M4 20h4L19 9l-4-4L4 16z M14 6l4 4',
  wallet: 'M3 6h18v13H3z M3 10h18 M16 15h2',
  bank: 'M3 10h18 M5 10v8 M9 10v8 M15 10v8 M19 10v8 M3 21h18 M12 3l9 5H3z',
  check: 'M4 12l5 5L20 6',
  swap: 'M4 8h13l-3-3 M20 16H7l3 3',
  chart: 'M4 20V11 M10 20V5 M16 20v-6 M21 20H3',
  spark: 'M12 3l1.8 4.7L18.5 9.5l-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8z',
  gear: 'M4 6h9 M17 6h3 M15 4v4 M4 12h3 M11 12h9 M9 10v4 M4 18h11 M19 18h1 M17 16v4',
  scan: 'M4 8V5h3 M17 5h3v3 M20 16v3h-3 M7 19H4v-3 M7 12h10',
  issue: 'M4 7h16v13H4z M9 7V4h6v3 M9 13l2 2 4-4',
};

/** Bəndin ikonu (yoxdursa qrupun ikonu). */
export const NAV_ICON: Partial<Record<NavKey, string>> = {
  sales: IC.sale, receipts: IC.receipt, company: IC.doc, returns: IC.ret, shift: IC.shift, shipments: IC.issue,
  products: IC.box, stock: IC.store, purchase: IC.truck, warehouses: IC.store, stockTransfers: IC.swap, intake: IC.truck,
  vatCheck: IC.check, scanner: IC.scan, intakeApprovals: IC.check, import: IC.upload, customers: IC.users, suppliers: 'M3 21V10l6 3V9l6 3V5h6v16z M7 17h2 M12 17h2 M17 17h1', contracts: IC.pen,
  financePayment: IC.wallet, financeAccounts: IC.bank, transfers: IC.swap, approvals: IC.check, reports: IC.chart, ai: IC.spark, settings: IC.gear,
};

export const NAV: NavSection[] = [
  { key: 'sales', label: 'Yeni satış', group: 'satis', permission: 'sale.create', module: null },
  { key: 'receipts', label: 'Satışlar', group: 'satis', permission: 'report.view', module: null },
  { key: 'company', label: 'Şirkət satışı', group: 'satis', permission: 'sale.company', module: null },
  { key: 'returns', label: 'Qaytarma', group: 'satis', permission: 'sale.return', module: null },
  { key: 'shift', label: 'Kassa növbəsi', group: 'satis', permission: 'shift.manage', module: null },
  { key: 'shipments', label: 'Verilməli mallar', group: 'satis', permission: 'stock.issue', module: 'two_step' },
  { key: 'products', label: 'Məhsullar', group: 'anbar', permission: 'product.view', module: null },
  { key: 'stock', label: 'Anbar qalığı', group: 'anbar', permission: 'stock.view', module: null },
  { key: 'purchase', label: 'Alış', group: 'anbar', permission: 'purchase.view', module: null },
  // Anbar tənzimləməsi «Mal və anbar»da (Tənzimləmə qrupu tək bənddir — birbaşa keçid qalsın)
  { key: 'warehouses', label: 'Anbarlar', group: 'anbar', permission: 'settings.users', module: null },
  { key: 'stockTransfers', label: 'Yerdəyişmə', group: 'anbar', permission: 'stock.view', module: 'multi_warehouse' },
  { key: 'intake', label: 'Malı aldım', group: 'anbar', permission: 'stock.receive', module: null },
  // Mobil skaner (KT-108): telefonda qiymət/qalıq, qəbul; tam ekran (/skaner)
  { key: 'scanner', label: 'Skaner', group: 'anbar', permission: 'product.view', module: null },
  { key: 'intakeApprovals', label: 'Qəbul təsdiqi', group: 'anbar', permission: 'approve.accounting', module: null },
  { key: 'import', label: 'Excel idxalı', group: 'anbar', permission: 'import.excel', module: null },
  // XİF MN üzrə ƏDV yoxlaması (KT-69): uyğun gəlməyən mallar, «Seçimim düzdür»
  { key: 'vatCheck', label: 'ƏDV yoxlaması', group: 'anbar', permission: 'product.edit', module: null },
  { key: 'customers', label: 'Müştəri bazası', group: 'musteri', permission: null, module: 'customers' },
  { key: 'suppliers', label: 'Təchizatçılar', group: 'musteri', permission: 'purchase.view', module: null },
  { key: 'contracts', label: 'Müqavilələr', group: 'musteri', permission: 'contract.manage', module: 'contracts' },
  { key: 'financePayment', label: 'Yeni ödəniş', group: 'maliyye', permission: 'approve.accounting', module: null },
  { key: 'financeAccounts', label: 'Hesablar', group: 'maliyye', permission: 'approve.accounting', module: null },
  { key: 'transfers', label: 'Köçürmələr', group: 'maliyye', permission: 'approve.accounting', module: null },
  { key: 'approvals', label: 'Təsdiq gözləyənlər', group: 'maliyye', permission: 'approve.accounting', module: 'accounting_approval' },
  { key: 'reports', label: 'Hesabatlar', group: 'hesabat', permission: 'report.view', module: null },
  { key: 'ai', label: 'Köməkçi (AI)', group: 'hesabat', permission: 'ai.ask', module: null },
  { key: 'settings', label: 'Tənzimləmə', group: 'ayar', permission: 'settings.users', module: null },
];

export type NavState = 'visible' | 'locked' | 'hidden';

/**
 * Bölmənin vəziyyəti. modules — obyektin modul siyahısı (yüklənməyibsə null).
 * Modula bağlı bölmə modul siyahısı yüklənənə qədər gizlənir (yanlış «açıq» görünməsin).
 */
export function navState(section: NavSection, permissions: string[], modules: ModuleItem[] | null): NavState {
  if (section.permission && !permissions.includes(section.permission)) return 'hidden';
  if (!section.module) return 'visible';
  if (modules === null) return 'hidden';
  const m = modules.find((x) => x.code === section.module);
  if (!m) return 'hidden';
  return m.open ? 'visible' : 'locked';
}

/** Görünən bölmələr. Kilidli (paketdə olmayan) modul göstərilmir — yalnız «visible». */
export function menu(permissions: string[], modules: ModuleItem[] | null): NavSection[] {
  return NAV.filter((section) => navState(section, permissions, modules) === 'visible');
}

/** Menyu qrupları və içindəki görünən bölmələr (boş qrup yoxdur). */
export function menuGroups(permissions: string[], modules: ModuleItem[] | null): { group: NavGroup; items: NavSection[] }[] {
  const items = menu(permissions, modules);
  return GROUPS.map((group) => ({ group, items: items.filter((i) => i.group === group.key) })).filter((g) => g.items.length > 0);
}

export function sectionOf(key: NavKey): NavSection | undefined {
  return NAV.find((s) => s.key === key);
}

export function groupOf(key: NavGroupKey): NavGroup {
  return GROUPS.find((g) => g.key === key)!;
}
